/**
 * Global asset helper to handle images.
 *
 * File: \src\components\general\assets\AssetHelper.ts
 * Created Date: Tuesday, June 13th 2023, 10:27:33
 * Author: Herrmann Sascha (HAU-EDCP)
 * -----
 * Last Modified: July 10th 2023, 13:32:03
 * Modified By: Herrmann Sascha (HAU-EDCP)
 * -----
 * Copyright (c) 2017-2023 Liebherr-Digital Development Center GmbH
 */

import company_logo_dark from '@/assets/company_logo_dark.svg';
import company_logo_white from '@/assets/company_logo_white.svg';
import company_logo_wepa from '@/assets/company_logo_wepa.svg';
import maintenance from '@/assets/maintenance.png';
import carousel_liebherr_1 from '@/assets/carousel_liebherr_1.jpg';
import carousel_liebherr_2 from '@/assets/carousel_liebherr_2.jpg';
import carousel_liebherr_3 from '@/assets/carousel_liebherr_3.jpg';
import carousel_liebherr_4 from '@/assets/carousel_liebherr_4.jpg';
import chrome from '@/assets/chrome.png';
import firefox from '@/assets/firefox.png';
import edge from '@/assets/edge.png';
import safari from '@/assets/safari.png';

import notification_info_template_v1 from '@/assets/notification_info_template_v1.svg';
import notification_info_template_v2 from '@/assets/notification_info_template_v2.svg';
import notification_template_v1 from '@/assets/notification_template_v1.svg';
import notification_template_v2 from '@/assets/notification_template_v2.svg';

// Sorted for faster check, please leave it sorted!!
export default {
  carousel_liebherr_1,
  carousel_liebherr_2,
  carousel_liebherr_3,
  carousel_liebherr_4,
  chrome,
  company_logo_dark,
  company_logo_white,
  company_logo_wepa,
  edge,
  firefox,
  maintenance,
  notification_info_template_v1,
  notification_info_template_v2,
  notification_template_v1,
  notification_template_v2,
  safari
};
